/**
 * @class Oskari.userinterface.component.ColorPickerInput
 *
 * Color picker component with default color palette
 */
Oskari.clazz.define('Oskari.userinterface.component.ColorPickerInput',
/**
 * @method create called automatically on construction
 * @param object options colorPicker options for customizing spectrum component
 */
function (options) {
  var me = this;
  if (!options) {
    options = {};
  }
  me._clazz = 'Oskari.userinterface.component.ColorPickerInput';
  me._element = document.createElement('label');
  me._input = document.createElement('input');
  me._titleEl = document.createElement('span');
  me._titleEl.style.display = 'none';
  me._element.appendChild(me._input);
  me._element.appendChild(me._titleEl);
  me._element.className = options.className ? options.className : 'oskari-formcomponent oskari-colorpickerinput';
  me._input.type = 'text';
  me._input.onchange = function () {
    me._valueChanged();
  };
  me._input.input = me._input.onchange;
  me._input.onkeyup = me._input.onchange;
  me._colorPickerOptions = {
    color: '#818282',
    preferredFormat: 'rgb',
    showInput: true,
    clickoutFiresChange: true,
    chooseText: Oskari.getMsg('DivManazer', 'buttons.ok'),
    cancelText: '',
    localStorageKey: 'colorpicker',
    showPalette: true,
    hideAfterPaletteSelect: true,
    showAlpha: false,
    palette: [['#ffffff', '#666666'], ['#ffde00', '#f8931f'], ['#ff3334', '#bf2652'], ['#000000', '#cccccc'], ['#652d90', '#3233ff'], ['#26bf4b', '#00ff01']],
    maxSelectionSize: 2
  };
  jQuery.extend(me._colorPickerOptions, options);
  jQuery(me._input).spectrum(me._colorPickerOptions);
}, {
  /**
   * @method focus
   * Focuses the component.
   */
  focus: function focus() {
    this._input.focus();
  },
  isEnabled: function isEnabled() {
    return !this._input.disabled;
  },
  _valueChanged: function _valueChanged() {
    if (this.getHandler()) {
      this.getHandler()(this.getValue());
    }
  },
  /**
   * @method _setEnabledImpl
   */
  _setEnabledImpl: function _setEnabledImpl(enabled) {
    var action = enabled ? 'enable' : 'disable';
    jQuery(this._input).spectrum(action);
  },
  getName: function getName() {
    return this._input.name;
  },
  /**
   * @method setName
   */
  setName: function setName(name) {
    this._input.name = name || '';
  },
  getPlaceHolder: function getPlaceHolder() {
    return this._input.placeholder;
  },
  setPlaceHolder: function setPlaceHolder(placeholder) {
    this._input.placeholder = placeholder;
  },
  /**
   * @method _setRequiredImpl
   */
  _setRequiredImpl: function _setRequiredImpl() {
    this._input.required = this.isRequired();
  },
  getTitle: function getTitle() {
    return this._titleEl.textContent;
  },
  /**
   * @method setTitle
   */
  setTitle: function setTitle(title) {
    this._titleEl.textContent = '';
    if (title !== null && title !== undefined) {
      this._titleEl.style.display = '';
      this._titleEl.appendChild(document.createTextNode(title));
    } else {
      this._titleEl.style.display = 'none';
    }
  },
  getTooltip: function getTooltip() {
    return this._element.title;
  },
  /**
   * @method setTooltip
   */
  setTooltip: function setTooltip() {
    this._element.title = this.getTooltip();
  },
  getValue: function getValue() {
    return jQuery(this._input).spectrum('get') != null ? jQuery(this._input).spectrum('get').toHexString() : null;
  },
  /**
   * @method setValue
   */
  setValue: function setValue(value) {
    return jQuery(this._input).spectrum('set', value);
  },
  /**
   * @method _setVisibleImpl
   */
  _setVisibleImpl: function _setVisibleImpl() {
    this.getElement().style.display = this.isVisible() ? '' : 'none';
  },
  /**
   * @method reflow
   * Resets the positioning of the container element.
   */
  reflow: function reflow() {
    jQuery(this._input).spectrum('reflow');
  }
}, {
  extend: ['Oskari.userinterface.component.FormComponent']
});